import _ from 'underscore'
import { pay, popShow, goodsDetailShow } from './mall.event'
import { toJSONHelper } from '../utils/toJSONHelper'
import Logger from 'Logger'

import store from '../store'
import { checkIsGoldClass, BOUNS_PRICE } from '../config'

/**
 * 결제 팝업 호출 핸들러
 */

export function openPayPopup(event) {
  event.preventDefault()
  var $target = $(event.currentTarget)
  var isGift = $target.hasClass('poker-mall-item__gift')
  var templateName = isGift ? 'gift' : 'normal'
  var goodsList = toJSONHelper(this.collection.where({ isChecked: true }))

  var disableGoodsCounter = goodsList.length > 1

  if (!disableGoodsCounter && !$target.hasClass('poker-mall-btn__submit')) {
    goodsList = toJSONHelper(
      this.collection.where({ goods_id: $target.data('id') })
    )
  }

  if (goodsList.length === 0) {
    popShow({ message: '선택된 상품이 없습니다.' })
    return
  }

  pay({
    template: templateName,
    goodsList: goodsList,
    disableGoodsCounter: isGift ? true : disableGoodsCounter,
  })
}

/**
 * 클래스 결제 팝업 호출 핸들러
 */
export function openPayAuto(event) {
  event.preventDefault()
  var $target = $(event.currentTarget)
  var goodsId = $target.data('id')
  var templateName = $target.data('template-name')
  var isGoldClass = checkIsGoldClass()
  var onlyGoldclassGoods = $target.data('goldclass-only')
  var goodsList = toJSONHelper(this.collection.where({ goods_id: goodsId }))

  if (!isGoldClass && onlyGoldclassGoods) {
    popShow({
      title: '구매 불가',
      message: '골드클래스 회원만 <br /> 구매할 수 있는 전용 상품 입니다.',
      confirmText: '클래스 상품보기',
      confirmBtnColor: 'red',
      onConfirm: function () {
        $('[data-filter="auto"]').trigger('click')
        this.hide()
      },
    })
    return false
  }

  pay({
    template: templateName,
    goodsList: goodsList,
  })
}

/**
 * 아이템 상세보기 팝업 호출 핸들러
 */
export function detailHandler(event) {
  event.preventDefault()
  var $target = $(event.currentTarget)
  goodsDetailShow($target.data('detail-pop'), this)
}

/**
 * 꾸미기 / 이모티콘 페이지의 다중 아이템 선택 핸들러
 */
export function selectMultiGoods(event) {
  event.preventDefault()
  var $target = $(event.currentTarget)
  var currentModel = this.collection.where({ goods_id: $target.data('id') })
  var newCheck = !currentModel[0].get('isChecked')

  var selectedGoods = this.collection.getSelectedGoods()
  var purchaseLimit = store.list.get('purchaseLimit')
  var selectedGoodsPrice =
    selectedGoods.goodsPrice + currentModel[0].get('goods_price')

  /**
   * PRODPOKER-6381 : 2022-03
   * 다중 아이템 선택시 목록 API에서 받은 구매한도를 가지고 구매 가능 여부를 체크하나
   * 이 경우 기본 구매한도인지, 셀프케어 구매한도인지 체크하기가 복잡하여 셀프케어용 메시지로 변경
   */
  if (newCheck && selectedGoodsPrice > purchaseLimit) {
    popShow({
      message:
        '설정한 월구매금액을 초과하여<br/> 더 이상 선택할 수 없습니다.<br /><br /><span>월구매금액 변경은 내정보&gt;셀프케어에서 가능합니다.</span>',
    })
    return
  }

  if (newCheck && selectedGoods.goodsCount >= 10) {
    popShow({
      message: '1회 10개까지 구매할 수 있습니다.',
    })
    return
  }

  currentModel[0].set({ isChecked: newCheck })
  $target
    .removeClass('selected--false selected--true')
    .addClass('selected--' + newCheck)
}

/**
 * 꾸미기 / 이모티콘의 아이템 상세보기 핸들로 : 타이틀의 제목을 가져옴
 */
export function detailWithTitleHandler(event) {
  event.preventDefault()
  var $target = $(event.currentTarget)
  var firstGoodsId = $target
    .parent()
    .siblings('ul')
    .find('li:visible:eq(0)>a')
    .data('id')

  var targetGoods = toJSONHelper(
    this.collection.where({ goods_id: firstGoodsId })
  )

  var popupData = _.extend($target.data('detail-pop'), {
    title: $target.prev().html(),
    message: targetGoods[0].detail_descr || '',
    detailImgUrl: targetGoods[0].detail_img_url || '',
    detail: targetGoods[0].goods_descr_2 || '',
  })
  goodsDetailShow(popupData, this)
}

/**
 * 가격 필터
 */
export function priceFilterHandler(event) {
  event.preventDefault()
  var $head = $('.poker-mall-decoration__head')
  var bounsClassName = 'bouns-reward'
  var $target = $(event.currentTarget)
  var filterPrice = $target
    .siblings()
    .removeClass('on')
    .end()
    .addClass('on')
    .data('filter-price')

  var effectPeriod = $('[data-price]')
    .show()
    .each(function () {
      var $this = $(this)
      $this.data('price') === filterPrice ? $this.show() : $this.hide()
    })
    .filter(':visible')
    .eq(0)
    .data('effect-period')

  var periodText = effectPeriod ? '(' + effectPeriod + '일 이용권)' : ''

  if ($head && _.contains(BOUNS_PRICE, filterPrice)) {
    $head.addClass(bounsClassName).data('bouns-price', filterPrice)
  } else {
    $head.removeClass(bounsClassName).removeData('bouns-price')
  }

  $('.insert-period').html(periodText)
  this.resetSelected()
}

/**
 *  드롭 다운
 */
export function categoryFilterHandler(event) {
  event.preventDefault()
  var $target = $(event.currentTarget)
  var $selected = $('.poker-mall-dropdown>p')

  $('.poker-mall-decoration__contents').find('>div').hide()

  $($target.data('filter-target')).show()
  $selected.text($target.text())
  this.resetSelected()
}

/**
 * 팝업 콜백 핸들러
 */
export function callbackHandler(event) {
  event.preventDefault()
  var callbackName = $(event.currentTarget).data('callback')
  Logger.info('callbackName', callbackName)

  // DOM에 정의된 data-callback 함수명을 읽어 Backbone 모델에 정의된 함수를 실행
  var callbackFunc = this.model.get(callbackName)

  if (_.isFunction(callbackFunc)) {
    Logger.info('callback called:', callbackName)
    callbackFunc.call(this.model)
  }
}
